import React from 'react';

export const isEmbedded = window !== window.top || localStorage.getItem('chainParam');

export const PrizesCurrency = ({ chainLogin = '', short = false }) => {
  return isEmbedded
    ? <>${chainLogin.toUpperCase()}{short ? '/' : ' or '}${chainLogin === 'hive' ? 'WAX' : 'HIVE'}</>
    : <>${chainLogin.toUpperCase()}</>;
};
